module.exports = __webpack_public_path__ + "static/media/ice-cream.81c2d3f6.svg";